module.exports = __webpack_public_path__ + "media/images/b-9fc9bdecead5a4f0a1777475f18f4741.gif";